import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 样式引入
import './assets/iconfont/iconfont.css';
import "./assets/css/common.less";
import "./assets/EBUI/main.less";

// 系统公告所用指令
import './assets/js/sysNotice';
// Sentry未使用
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
// Vue.prototype.$sentry = Sentry;
// const dayjs = require("dayjs");
window.env=process.env.NODE_ENV
// const DSN = process.env.NODE_ENV === 'production' ? 'http://2d2c93a69aba40e4b99fe287a8eba73d@sentry.eybond.com/6':'http://5bff713fced740fea6fea4f1421a5110@sentry.eybond.com/5'
// if (process.env.NODE_ENV !== 'development') {
//   Sentry.init({
//     dsn: DSN,
//     integrations: [new Integrations.Vue({Vue, attachProps: true,logErrors: true,})],
//     release:dayjs().format('YYYY-MM-DD HH:mm:ss'),
//     tracesSampleRate: 1.0,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//   });
// }

//滑动验证
// import SlideVerify from 'vue-monoplasty-slide-verify';
// 导出excel表格
// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)
// 国际化
import lang from '@/i18n';
// Vue.use(SlideVerify)

Vue.use(ElementUI, {
  i18n: (path, options) => {
    let value = lang.i18n.t(path, options)
    if (value !== null && value !== undefined) {
      return value
    }
    return ''
  }
})
Vue.prototype.$lang = lang
// 请求
import request from '@/assets/js/request'
Vue.prototype.$request = request
Vue.prototype.$filter = filters
// 过滤器及全局方法
import filters from '@/assets/js/filter'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.$filter = filters
// 指令(点击空白关闭搜索)
import directives from '@/assets/js/directive'
Object.keys(directives).forEach((key)=>{
  Vue.directive(key,directives[key])
})
// 工具
import tool from '@/assets/js/tool'
Object.keys(directives).forEach((key)=>{
  Vue.directive(key,directives[key])
})
Vue.prototype.$tool = tool
// 全局混入(公共方法：任意组件内可直接this.xxx()调用)
import globalMixin from '@/assets/js/mixin'
Vue.mixin(globalMixin)

// 解决chrome浏览器近期2024年中旬更新后出现的el-radio单选框报错（有关标签属性-aria-hidden）
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

// 新手指引(intro)
// import VueIntro from 'vue-introjs';
// Vue.use(VueIntro);
// import 'intro.js/introjs.css';
// 新手指引(driver)
// import Driver from 'driver.js';
// import 'driver.js/dist/driver.min.css';
// Vue.prototype.$driver = new Driver({
//   allowClose: false,
//   doneBtnText: '完成',
//   closeBtnText: '关闭',
//   stageBackground: '#fff',
//   nextBtnText: '下一步',
//   prevBtnText: '上一步',
// })

// 获取并初始化皮肤
store.getters.getSkin

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n: lang.i18n,
  render: h => h(App)
}).$mount('#app')
